
import React from 'react';
import { portfolioData } from '../data/portfolioData';

const Footer = () => {
    return (
        <footer style={{
            padding: '4rem 0',
            backgroundColor: 'var(--color-bg-secondary)',
            marginTop: 'auto',
            borderTop: '1px solid var(--color-border)'
        }}>
            <div className="container" style={{ textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', marginBottom: '2rem' }}>
                    {portfolioData.socialLinks.map((link, index) => (
                        <a
                            key={index}
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontSize: '1.5rem', color: 'var(--color-text-secondary)', transition: 'color 0.3s' }}
                            className="social-icon"
                        >
                            {link.icon}
                        </a>
                    ))}
                </div>
                <p style={{ fontSize: '0.9rem', margin: '0 auto' }}>
                    &copy; {new Date().getFullYear()} {portfolioData.name}. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
